import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";
import {
  getMultiPlanPrices,
  getSinglePlanPrice,
  isSinglePlanPricingModel,
} from "../../../../components/task/payment/planTypes";

const formatPrice = (n: number) => n.toLocaleString("ko-KR");

export default function Habit_6_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const pricingModel = user?.pricingModel ?? "aeg";
  const isSinglePlan = isSinglePlanPricingModel(pricingModel);
  const standardPrice = isSinglePlan
    ? (getSinglePlanPrice(pricingModel) ?? 395000)
    : (getMultiPlanPrices(pricingModel)?.challenger ?? 395000);

  const standardPriceText = formatPrice(standardPrice);

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/habit/7`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ paddingBottom: "40px" }}>
      <Stack
        spacing={10}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"매일 쌓여가는 변화."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "디스턴싱은 매일 꾸준히 참여하며 차곡차곡 변화를 쌓아가는 프로그램입니다."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {`프로그램은 100일간 진행되며, 비용은 챌린저 플랜 기준 ${standardPriceText}원입니다.`}
          </CustomTypography>
        </Stack>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
